export const SENTLIST_SEARCH = 'SENTLIST_SEARCH';
export const SENTLIST_PAGE = 'SENTLIST_PAGE';
export const SENTLIST_STARTDATE = 'SENTLIST_STARTDATE';
export const SENTLIST_ENDDATE = 'SENTLIST_ENDDATE';
